/***************************************** Mini Cart *****************************/

// subscription benefits
const benefits = ["Price locked", "Fast & free shipping", "Cancel anytime"]

// discount UI elements
const discountWrap = document.querySelector('#miniCartFooterDiscountCodeWrap');
const discountButton = document.querySelector('#miniCartFooterDiscountFieldButton');
const discountInvalid = document.querySelector('#miniCartFooterDiscountInvalid');

/********************* Product Data (/cart?view=product-json) *********************/

// general product data, populated by the productDataReady fetch below. These used to be
// rendered as an inline script in theme-mini-cart.liquid; they now load from the
// cart.product-json view so the section ships no inline script tags.
let isCustomer = false;
let isCanada = false;
const variantIDToSellingPlanID = {};
const variantIDToSellingPlanName = {};
const variantIDToProduct = {};
const variantIDToSellingPlan = {};
const handleToVariantID = {};

// upsell matrix
const upsellMatrix = {
    "16-rolls": {
        handle: "16-rolls-4-boxes",
        replace_in_cart: true,
    },
    "32-rolls": {
        handle: "32-rolls-8-boxes",
        replace_in_cart: true,
    },
    "96-rolls": {
        handle: "12-boxes",
        replace_in_cart: false,
    },
    "16-rolls-ca": {
        handle: "16-rolls-4-boxes-ca",
        replace_in_cart: true,
    },
    "32-rolls-ca": {
        handle: "32-rolls-8-boxes-ca",
        replace_in_cart: true,
    },
    "96-rolls-ca": {
        handle: "12-boxes-ca",
        replace_in_cart: false,
    }
}

// default cadence matrix
const defaultCadenceMatrix = {
    "16-rolls": "6 Weeks",
    "32-rolls": "12 Weeks",
    "96-rolls": "18 Weeks",
    "12-boxes": "12 Weeks",
    "16-rolls-ppt": "8 Weeks",
    "30-rolls-ppt": "12 Weeks",
    "16-rolls-ca": "6 Weeks",
    "32-rolls-ca": "12 Weeks",
    "96-rolls-ca": "18 Weeks",
    "12-boxes-ca": "12 Weeks",
    "16-rolls-ppt-ca": "8 Weeks",
    "30-rolls-ppt-ca": "12 Weeks",
}

// special bundle pricing for 16 and 32 rolls in US and CA
const bundlePricing = {
    "16-rolls-4-boxes": 13,
    "32-rolls-8-boxes": 24,
    "16-rolls-4-boxes-ca": 13,
    "32-rolls-8-boxes-ca": 24
}

// fetch the product data once; cart flows await this before reading the maps above
const productDataReady = fetch("/cart?view=product-json")
    .then(response => response.json())
    .then(data => {
        // request flags
        isCustomer = data.is_customer;
        isCanada = data.is_canada;

        // build the lookup maps keyed by handle / variant id
        data.products.forEach(entry => {
            handleToVariantID[entry.handle] = entry.product.variants[0].id;
            variantIDToProduct[entry.product.variants[0].id] = entry.product;

            entry.variants.forEach(variant => {
                variantIDToSellingPlan[variant.id] = variant.selling_plan;
                variantIDToSellingPlanName[variant.id] = variant.selling_plan_name;
                variantIDToSellingPlanID[variant.id] = variant.selling_plan_id;
            });
        });
    })
    .catch(error => {
        console.error("Mini cart product data failed to load.", error);
    });

// flatten selling plans across all selling_plan_groups (each frequency is its own group now)
function flattenSellingPlans(product) {
    if (!product || !product.selling_plan_groups) {
        return [];
    }
    return product.selling_plan_groups.flatMap(group => group.selling_plans || []);
}

// strip "Delivery every " prefix from a selling plan name
function planFrequencyLabel(planName) {
    if (!planName) {
        return "";
    }
    return planName.replace("Delivery every ", "");
}

// find the upsell matrix entry whose offer matches a product handle
function upsellMatrixEntry(handle) {
    return Object.values(upsellMatrix).find(upsell => handle === upsell.handle);
}

// find the original product handle whose matrix entry offers a product handle
function upsellMatrixSourceHandle(handle) {
    const entry = Object.entries(upsellMatrix).find(([, upsell]) => handle === upsell.handle);
    if (!entry) {
        return null;
    }
    return entry[0];
}

// pick the selling plan id to attach when adding or swapping a product for an existing subscription;
// priority: the handle's default cadence, then the original cadence, then the first plan
function matchSellingPlan(product, originalPlanName) {
    const plans = flattenSellingPlans(product);
    if (plans.length === 0) {
        return null;
    }

    // try the default cadence for this handle, case insensitive since ppt plan names use lowercase "weeks"
    if (defaultCadenceMatrix[product.handle]) {
        const defaultCadence = defaultCadenceMatrix[product.handle].toLowerCase();
        const defaultPlan = plans.find(plan => plan.name.toLowerCase().includes(defaultCadence));
        if (defaultPlan) {
            return defaultPlan.id;
        }
    }

    // try to match the original cadence
    const originalPlan = plans.find(plan => plan.name === originalPlanName);
    if (originalPlan) {
        return originalPlan.id;
    }

    // fall back to the first plan
    return plans[0].id;
}

// format a product handle into a pack label, stripping the ppt marker so labels read like the tp ones
function formatPackLabel(handle) {
    const cleanKey = handle.replace('-ppt', '');
    if (cleanKey.includes('boxes')) {
        return cleanKey.replace('-', ' ').replace('rolls', ' +').replace('-', ' ').replace('-boxes', '').replace('-ca', '').replace('ca', '');
    }
    return cleanKey.replace('-', ' ').replace('-', ' ').replace('-boxes', ' tissue').replace('-ca', '').replace('ca', '');
}

/********************* Cart Display Order *********************/

// when a line entered the cart, from the _added_at stamp every addProduct caller sets. Unstamped
// lines (legacy carts, cart permalinks) count as newest and land last, oldest first among themselves
function addedTime(item) {
    if (item.properties?._added_at) {
        return parseInt(item.properties._added_at);
    }
    return Number.MAX_SAFE_INTEGER - cart.items.indexOf(item);
}

// toggle the loading state on the mini cart content
function setCartLoading(on) {
    document.querySelector('#miniCartContentWrapper').classList.toggle("loading", on);
}

// flag for user opening cart with items in it, used to determine whether to auto close empty cart or not
let openWithItems = false;

// check that we should apply the discount code
const hasWelcomeCode = !!welcomeDiscount.code;

// shopify refuses a valid code on an empty cart because there are no line items to allocate against,
// so a verdict only means anything once something is in the cart
function welcomeCodeRefused() {
    if (!hasWelcomeCode || cart.item_count === 0) {
        return false;
    }
    return !!cart.discount_codes?.some(code => {
        return code.code.toUpperCase() === welcomeDiscount.code.toUpperCase() && code.applicable === false;
    });
}

// helper function to determine if customer is eligible for welcome discount
// removes the discount language from the cart and shows invalid language in the discount section
function eligibleWelcomeCode() {
    // toggle rather than only ever adding, otherwise the denial sticks around after the cart changes
    // into something the code does apply to
    if (!welcomeCodeRefused()) {
        discountInvalid.classList.remove("active");
        return;
    }

    // show the invalid line if the customer isn't eligible
    discountInvalid.innerHTML = `Sorry, you're not eligible for the ${welcomeDiscount.code} discount.`;
    discountInvalid.classList.add("active");
}

// should we push the code onto the cart? an empty cart has nothing to apply it to, and a cart that
// already carries a code must not be overwritten - the visitor may have typed that one in themselves
function shouldApplyWelcomeCode() {
    return hasWelcomeCode && cart.item_count > 0 && (!!cart.discount_codes === false || cart.discount_codes?.length === 0);
}

// make sure welcome discount code is applied
if (shouldApplyWelcomeCode()) {
    (async function () {
        await applyWelcomeDiscount();
        eligibleWelcomeCode();
    }());
}

// open cart
async function openCart(skipFetch = false) {
    // make sure the product data feed has loaded before rendering anything
    await productDataReady;

    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }

    document.querySelector('#miniCart').classList.add('active');
    document.querySelector("body").classList.add("noScroll");


    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // self-heal the welcome code, then show the invalid line if the customer isn't eligible. has to
    // sit below the fetch: the liquid bootstrapped cart carries no discount_codes at all, so the
    // check would read undefined and silently never fire on the first open
    if (shouldApplyWelcomeCode()) {
        await applyWelcomeDiscount();
    }
    eligibleWelcomeCode();

    // start loading on the cart
    setCartLoading(true);

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeaderTitle").classList.remove("active");
    document.querySelector("#miniCartContent").classList.remove("active");
    document.querySelector('#miniCartUpsells').classList.remove('active');

    // stop loading on the cart
    setCartLoading(false);

    //  update cart count in header nav and mini cart header
    document.querySelector('#headerBodyIconsCartCount').textContent = cart.item_count;
    document.querySelector("#miniCartHeaderTitle").textContent = `Cart ( ${cart.item_count} )`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        // animate empty state
        document.querySelector("#miniCartEmpty").classList.add("active");

        // drop a leftover code the visitor typed in, but keep the welcome code: it re-evaluates by
        // itself as soon as something is back in the cart, so clearing it only costs a round trip
        const strayCode = cart.discount_codes?.some(code => {
            return code.code.toUpperCase() !== welcomeDiscount.code.toUpperCase();
        });

        if (strayCode) {
            cart = await updateCart({discount: ""});
        }

        // this branch returns before the discount sync below, so reset the field here or it keeps
        // showing the last applied code against an empty cart
        cleanUpDiscountCode();

        // close the cart automatically after 3.5 seconds if the user emptied their cart
        if (openWithItems === true) {
            setTimeout(async () => {
                // set the flag back to false
                openWithItems = false;

                // check if user has closed the cart already, if so, exit
                if (!document.querySelector("#miniCart").classList.contains("active")) {
                    return;
                }
                document.querySelector("#miniCart").classList.remove("active");
                // after we remove active, close the cart after a half second sleep
                await sleep(500);
                closeCart();

            }, 3500);
        }
        return;

    }

    // set flag for user opening cart with items in it
    openWithItems = true;

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // sync the discount UI with the cart's current discounts
    if (document.querySelector('#miniCartFooterDiscount')) {
        const discountForm = document.querySelector('#miniCartFooterDiscountField');
        const discountInput = document.querySelector('#miniCartFooterDiscountFieldInput');
        const discountButton = document.querySelector('#miniCartFooterDiscountFieldButton');
        const discountCodeWrap = document.querySelector('#miniCartFooterDiscountCodeWrap');

        // a code applied via a /discount/CODE link lands in cart.js but never in the field, so we mirror it in below
        const appliedCode = cart.discount_codes?.find(code => code.applicable === true);

        // product specific codes allocate at the line level and never appear in
        // cart_level_discount_applications, so key off the applied code and the cart wide total instead
        const codeDiscount = cart.original_total_price - cart.total_price;

        // no applicable code? reset the discount UI unless we have an auto applied discount
        if (!appliedCode) {
            cleanUpDiscountCode();
        } else {
            // rebuild the row every render so the amount tracks cart changes
            discountCodeWrap.innerHTML = "";
            if (codeDiscount > 0) {
                discountCodeWrap.insertAdjacentHTML("beforeend", `
                    <div class="miniCartFooterDiscountCode">
                        <span class="miniCartFooterDiscountCodeTitle">${appliedCode.code} discount</span>
                        <span class="miniCartFooterDiscountCodePrice">-${price(codeDiscount)}</span>
                    </div>
                `);
                discountCodeWrap.classList.add('active');
            } else {
                discountCodeWrap.classList.remove('active');
            }

            // reflect the applied code in the input field and mark it applied (covers auto applied codes from a /discount/CODE link)
            discountInput.value = appliedCode.code;
            discountForm.classList.add("validCode");
            discountButton.innerHTML = "Applied";
            discountButton.classList.add("unclickable");
        }
    }

    // show main cart sections
    document.querySelector("#miniCartContent").classList.add("active");
    document.querySelector("#miniCartHeaderTitle").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // update subtotal-- (including any discounts)
    document.querySelector("#miniCartFooterPrice span").textContent = price(cart.total_price, true);

    // update the total savings

    let totalSavings = 0;
    let yearlySavings = 0;

    cart.items.forEach(item => {
        // check if item has a selling plan allocation
        if (item.selling_plan_allocation) {
            let comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;

            // determine the delivery cadence (in WEEKS)
            let cadence = parseInt((item.selling_plan_allocation.selling_plan.options[0].value).match(/\d+/g)[0]);

            // determine how many times per year deliveries can be made based on cadence
            let yearlyDeliveries = Math.floor((52 / cadence));

            if (comparePrice) {
                // pre-code line price so code discounts don't inflate the subscription savings
                let savings = comparePrice - item.original_line_price;
                if (savings > 0) {
                    yearlySavings += (savings * yearlyDeliveries);
                    totalSavings += savings;
                }
            }
        }
    })

    // total savings per each delivery
    document.querySelector('.miniCartFooterSaveInfoPer').textContent = `-${price(totalSavings, true)}`;

    // any subscriptions? if so, free shipping
    let shippingMessage = document.querySelector("#miniCartFooterShipping");
    if (subscriptionItems > 0) {
        // if the free shipping message isn't already active, add active
        if (!shippingMessage.classList.contains('active')) {
            shippingMessage.classList.add('active')
        }
        // hide the $0 saved message
        document.querySelector('#miniCartFooterSave').classList.remove('active');

        // update color of subtotal price to sub blue color
        document.querySelector('#miniCartFooterPrice').classList.add('active');
    } else {
        // remove the free shipping message
        shippingMessage.classList.remove('active')
        document.querySelector('#miniCartFooterPrice').classList.remove('active');

        // show the $0 saved message
        document.querySelector('#miniCartFooterSave').classList.add('active');

        // remove sub blue color from subtotal price
        document.querySelector('#miniCartFooterPrice').classList.remove('active');
    }

    // append cart oldest first by the _added_at stamp so changed lines keep their position and new additions land last
    const sortedItems = [...cart.items].sort(function (a, b) {
        return addedTime(a) - addedTime(b);
    });
    sortedItems.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // subscription HTML
        function purchaseType() {
            let comparePrice = null;
            let HTML = "One-time purchase";
            if (item.selling_plan_allocation) {
                //  append compare_at_price * quantity
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
                // check for savings, against the pre-code line price so code discounts don't inflate it
                if (comparePrice) {
                    let savings = comparePrice - item.original_line_price;
                    if (savings > 0) {
                        HTML = `<span>${price(savings, false)} Subscription Discount</span>`;
                    }
                }
                return `<div class="miniCartBodyItemType subscription">${HTML}</div>`;
            } else {
                return `<div class="miniCartBodyItemType">${HTML}</div>`;
            }
        }

        function upsellTitle() {
            // first check if this is an upsell item and it's not replacing in cart
            const matrixEntry = upsellMatrixEntry(variantIDToProduct[item.variant_id]?.handle);
            if (!matrixEntry || matrixEntry.replace_in_cart === false) {
                return "";
            }

            // find the original product handle the upsell replaced
            const upsellProduct = variantIDToProduct[item.variant_id];
            const sourceHandle = upsellMatrixSourceHandle(upsellProduct.handle);

            // get the product title
            let itemTitle = variantIDToProduct[handleToVariantID[sourceHandle]].title.replace("PlantPaper - ", "").replace("Rolls", "rolls PlantPaper");

            return `<div class="miniCartBodyItemLabel">${itemTitle}</div>`;
        }

        // calculate the pricing and insert into HTML
        function priceHTML() {
            let HTML = "";

            // get the prices
            const [comparePrice, realPrice] = computePrices();

            // check for a compare price
            if (comparePrice > realPrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            HTML += `<span class="${isSubscription()}">${price(realPrice, false)}</span>`;

            return HTML;
        }

        // shows the first order price using the discount shopify actually allocated to this line
        function discountHTML() {
            // only render money off a code shopify confirms is applicable to this cart
            if (!welcomeDiscountApplied() || !item.selling_plan_allocation) {
                return "";
            }

            // get the real price
            let realPrice = computePrices()[1];

            // the code allocates across the cart, so line_level_discount_allocations stays empty and
            // the per line amount lands on item.total_discount instead
            if (!item.total_discount) {
                return "";
            }

            // calculate the new pricing based on the applied discount
            return `<span class="firstOrder">First order ${price(realPrice - item.total_discount)}</span>`;
        }

        // helper function to simplify the price calculations
        function computePrices() {
            let comparePrice = 0;

            // check if this product is an upsell product that replaces an item in the cart
            let originalHandle = null;
            if (upsellMatrixEntry(variantIDToProduct[item.variant_id]?.handle)?.replace_in_cart === true) {
                originalHandle = upsellMatrixSourceHandle(variantIDToProduct[item.variant_id]?.handle);
            }

            // if we find the original product that was replaced, use its original and compare at price
            if (originalHandle != null) {
                if (variantIDToProduct[handleToVariantID[originalHandle]]) {
                    // get the product from the product array using the original handle
                    let originalProduct = variantIDToProduct[handleToVariantID[originalHandle]];
                    let originalSub = null;

                    // calculate the product pricing
                    let realPrice, comparePrice;
                    realPrice = comparePrice = originalProduct.variants[0].price * item.quantity;

                    // try to find the original subscription plan allocation if it exists
                    if (item.selling_plan_allocation) {
                        let currentPlan = item.selling_plan_allocation.selling_plan.name;
                        let plans = flattenSellingPlans(originalProduct);

                        // more than one selling plan? try to match it to the original cadence, defaulting to the first plan
                        if (plans.length > 1) {
                            originalSub = plans[0];
                            const matchedPlan = plans.find(plan => plan.name === currentPlan);
                            if (matchedPlan) {
                                originalSub = matchedPlan;
                            }
                        }
                        // determine the subscription discount based on the original subscription plan if it exists
                        if (originalSub != null) {
                            realPrice = (originalProduct.variants[0].price * (1 - (originalSub.price_adjustments[0].value / 100))) * item.quantity;
                        }
                    }

                    // collect and return the values
                    return [comparePrice, realPrice];
                }
            } else {
                // check for compare at price
                if (variantIDToProduct[item.variant_id] && variantIDToProduct[item.variant_id]?.compare_at_price) {
                    comparePrice = variantIDToProduct[item.variant_id].compare_at_price * item.quantity;
                }
                // check if selling_plan_allocation exists, if so append compare_at_price * quantity
                else if (item.selling_plan_allocation) {
                    comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
                }
                // collect and return the values
                return [comparePrice, item.original_line_price];
            }
        }

        // check if item is subscription
        function isSubscription() {
            if (item.selling_plan_allocation) {
                return 'subscription'
            }
            return "";
        }

        function frequencyOptions() {

            let HTML = ""
            if (item.selling_plan_allocation) {
                let frequencyName = planFrequencyLabel(item.selling_plan_allocation.selling_plan.name);

                HTML += `
                    <div class="miniCartBodyItemFrequencySelectOptions">
                        <div class="miniCartBodyItemFrequencySelectOptionsSelected" data-selling_plan="${item.selling_plan_allocation.selling_plan.id}">
                            <span>Delivered every<u class="editFrequency">${frequencyName}</u></span>
                        </div>
                        <button class="miniCartBodyItemFrequencySelectOptionsEdit">Edit</button>
                    </div>
                `;
            }
            return HTML;
        }

        // upgrade to subscription HTML
        function upgradeHTML() {
            // // check if it's already a subscription
            // if (item.selling_plan_allocation) {
            //     return "";
            // }

            // get the selling plan id for this variant if it exists
            let sellingPlanID;
            let sellingPlanName;

            // get the selling plans off the product
            let sellingPlans = flattenSellingPlans(variantIDToProduct[item.variant_id]);

            // check if default cadence matrix has an entry for this product, and if so, make that the default (case insensitive, ppt plan names use lowercase "weeks")
            let hasDefault = false;
            let defaultPlan = null;
            const defaultCadence = defaultCadenceMatrix[item.handle];

            if (sellingPlans && defaultCadence) {
                sellingPlans.forEach((sellingPlan) => {
                    if (sellingPlan.name.toLowerCase().includes(defaultCadence.toLowerCase())) {
                        hasDefault = true;
                        defaultPlan = sellingPlan;
                    }
                })
            }

            // check for selling plan on the variant
            if (item.selling_plan_allocation) {
                sellingPlanID = item.selling_plan_allocation.selling_plan.id;
                // check if this plan is the default cadence for this product, and if so, add "Most Popular"
                if (hasDefault && sellingPlanID === defaultPlan.id) {
                    sellingPlanName = planFrequencyLabel(item.selling_plan_allocation.selling_plan.name) + " (Most Popular)";
                } else {
                    sellingPlanName = planFrequencyLabel(item.selling_plan_allocation.selling_plan.name);
                }
            }
            // check if there was an original selling plan before the item was updated
            else if (item.properties._original_plan) {
                sellingPlanID = item.properties._original_plan;
                let plan = flattenSellingPlans(variantIDToProduct[item.variant_id]).find(plan => plan.id === sellingPlanID);

                // check if this the default cadence for this product, and if so, add "Most Popular"
                if (hasDefault && sellingPlanID === defaultPlan.id) {
                    sellingPlanName = planFrequencyLabel(plan.name) + " (Most Popular)";
                } else {
                    sellingPlanName = planFrequencyLabel(plan.name);
                }
            }
            // check if this item has a default cadence selling plan from the matrix, and if a plan exists for that plan
            else if (hasDefault) {
                sellingPlanID = defaultPlan.id;
                sellingPlanName = planFrequencyLabel(defaultPlan.name) + " (Most Popular)";
            } else
                // if not, check for any selling plan on the variant
            {
                sellingPlanID = variantIDToSellingPlanID[item.variant_id];
                sellingPlanName = planFrequencyLabel(variantIDToSellingPlan[item.variant_id]?.name);
            }
            // or exit if no selling plan id
            if (!sellingPlanID) {
                return "";
            }

            // determine the total with subscription items only, and apply the discount amount to that
            const subscriptionTotal = cart.items
                .filter(item => item.selling_plan_allocation)
                .reduce((sum, item) => sum + item.final_line_price, 0);

            // get the rest of the information off the product
            let planInfo = flattenSellingPlans(variantIDToProduct[item.variant_id]).find(plan => plan.id === sellingPlanID);

            // get the pricing adjustments from the subscription plan
            let adjustedPricing = planInfo.price_adjustments[0].value / 100;

            // determine the delivery cadence
            let cadence = parseInt((planInfo.name).match(/\d+/g)[0]);

            // yearly savings
            let yearlySavings = 0;

            // how deliveries per year?
            let yearlyDeliveries = Math.floor(52 / cadence);
            // estimate off the pre-code line price so code discounts don't shrink the pitch
            yearlySavings = (Math.ceil(adjustedPricing * (item.original_line_price / 100)) * 100) * yearlyDeliveries;

            // list out the benefits of subscribing, including the savings
            let HTML = "";
            HTML += `
                <div class="miniCartBodyItemUpgradeContentBenefitsItem">
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.924 0.042547C11.2972 0.25577 10.3393 0.892708 9.2896 1.79417C8.06826 2.84313 5.5917 5.29682 4.49919 6.54041L4.25765 6.81545L3.30814 6.38241C1.3986 5.51147 0.407267 5.37763 0.0953457 5.94866C-0.0933879 6.29406 -0.03562 6.41816 0.577309 6.98479C1.71053 8.03238 2.54593 9.07611 3.67307 10.8527C4.08453 11.5011 4.4243 11.974 4.48727 11.9858C4.79531 12.0431 4.86782 11.9599 5.2419 11.1209C5.70793 10.0756 6.7093 8.18854 7.276 7.28768C8.55712 5.25116 10.0666 3.45026 11.8101 1.87843C12.9546 0.846631 13.101 0.640355 12.9513 0.27103C12.8662 0.0611321 12.2634 -0.0729413 11.924 0.042547Z" fill="#153BFE"/>
                    </svg>
                    Save ${price(yearlySavings, true)} per year
                </div>
            `;

            // each of the benefits, added as an item
            benefits.forEach(benefit => {
                HTML += `
                    <div class="miniCartBodyItemUpgradeContentBenefitsItem">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.924 0.042547C11.2972 0.25577 10.3393 0.892708 9.2896 1.79417C8.06826 2.84313 5.5917 5.29682 4.49919 6.54041L4.25765 6.81545L3.30814 6.38241C1.3986 5.51147 0.407267 5.37763 0.0953457 5.94866C-0.0933879 6.29406 -0.03562 6.41816 0.577309 6.98479C1.71053 8.03238 2.54593 9.07611 3.67307 10.8527C4.08453 11.5011 4.4243 11.974 4.48727 11.9858C4.79531 12.0431 4.86782 11.9599 5.2419 11.1209C5.70793 10.0756 6.7093 8.18854 7.276 7.28768C8.55712 5.25116 10.0666 3.45026 11.8101 1.87843C12.9546 0.846631 13.101 0.640355 12.9513 0.27103C12.8662 0.0611321 12.2634 -0.0729413 11.924 0.042547Z" fill="#153BFE"/>
                        </svg>
                        ${benefit}
                    </div>
                `;
            })

            // get all of the selling plans off the product
            let plansHTML = "";

            // add all of the selling plans as options
            sellingPlans.forEach(plan => {
                // make sure we're not adding the currently selected plan again
                if (plan.id !== sellingPlanID) {
                    let frequency = planFrequencyLabel(plan.name);

                    // if this plan is the default cadence for this product, add "Most Popular" to the end of the frequency name
                    if (defaultPlan && plan.id === defaultPlan.id) {
                        frequency += " (Most Popular)";
                    }

                    plansHTML += `
                        <div class="miniCartBodyItemUpgradeContentFrequencySelectOption miniCartBodyItemUpgradeContentFrequencySelectRow" selling_plan="${plan.id}">
                            <span>${frequency}</span>
                        </div>
                    `;
                }
            })

            // pre-check the toggle when the item is already a subscription
            let checkedAttr = "";
            if (isSubscription() === 'subscription') {
                checkedAttr = "checked";
            }

            // show the welcome discount nudge for guests only
            let discountHTML = "";
            if (isCustomer === false) {
                discountHTML = `
                    <div class="miniCartBodyItemUpgradeContentDiscount">
                        Use code: <u><span class="bold">Welcome20</span></u> at checkout for an additional <u><span class="bold">${price(((item.original_line_price - (Math.ceil(adjustedPricing * (item.original_line_price / 100))) * 100) * 0.2), true)}</span></u> off your first order
                    </div>
                `;
            }

            // return HTML
            return `
                <div class="miniCartBodyItemUpgrade">
                    <div class="miniCartBodyItemUpgradeWrapper">
                        <div class="miniCartBodyItemUpgradeContent">
                            <div class="miniCartBodyItemUpgradeContentTop">
                                <div class="miniCartBodyItemUpgradeContentToggle" data-key="${item.key}" data-id="${item.variant_id}" data-quantity="${item.quantity}" data-plan="${sellingPlanID}">
                                    <label class="miniCartBodyItemUpgradeContentToggleInner">
                                        <input type="checkbox" ${checkedAttr} />
                                        <span class="miniCartBodyItemUpgradeContentToggleInnerSwitch"></span>
                                    </label>
                                    Subscribe & Save
                                </div>
                                <div class="miniCartBodyItemUpgradeContentPacks">${productPacks()}</div>
                                <button class="miniCartBodyItemUpgradeContentRemove">
                                    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.67875 0.0619176C6.35879 0.151113 6.06571 0.334773 5.79779 0.613973C5.36949 1.06036 5.20916 1.51717 5.20798 2.29437L5.20737 2.71178H2.85657C0.534158 2.71178 0.50388 2.71274 0.348947 2.79047C0.116495 2.90712 0 3.11 0 3.39818C0 3.68636 0.116495 3.88924 0.348947 4.00589C0.481154 4.07223 0.570985 4.08459 0.921722 4.08459H1.3377L1.35749 4.24228C1.36834 4.32902 1.65093 7.54723 1.98546 11.3939C2.31998 15.2405 2.60998 18.4482 2.62999 18.5219C2.67891 18.7027 2.78796 18.8387 2.9546 18.9268C3.09049 18.9987 3.18906 19 8.5 19C13.8109 19 13.9095 18.9987 14.0454 18.9268C14.212 18.8387 14.3211 18.7027 14.37 18.5219C14.39 18.4482 14.68 15.2405 15.0145 11.3939C15.3491 7.54723 15.6317 4.32902 15.6425 4.24228L15.6623 4.08459H16.0783C16.429 4.08459 16.5188 4.07223 16.6511 4.00589C16.8835 3.88924 17 3.68636 17 3.39818C17 3.11 16.8835 2.90712 16.6511 2.79047C16.4961 2.71274 16.4658 2.71178 14.1434 2.71178H11.7926L11.792 2.29437C11.7908 1.51717 11.6305 1.06036 11.2022 0.613973C10.9285 0.328762 10.6395 0.150149 10.3059 0.0600624C10.0054 -0.0210818 6.97089 -0.0195606 6.67875 0.0619176ZM10.156 1.48675C10.3842 1.64892 10.4326 1.78784 10.4326 2.28086V2.71178H8.5H6.56737L6.56751 2.27582C6.56762 1.89692 6.57757 1.82294 6.6436 1.71066C6.73075 1.56244 6.7922 1.505 6.94316 1.43065C7.03167 1.38701 7.31183 1.37922 8.53847 1.38616L10.0264 1.39462L10.156 1.48675ZM14.2979 4.16807C14.298 4.2852 13.1557 17.3591 13.1326 17.5066L13.1136 17.6272H8.5H3.88642L3.8673 17.5066C3.84486 17.3649 2.70211 4.27808 2.70211 4.16284V4.08459H8.5H14.2979L14.2979 4.16807ZM4.92707 5.49781C4.75302 5.58949 4.60593 5.79218 4.57636 5.98107C4.56552 6.05034 4.70453 8.26914 4.88526 10.9117C5.2049 15.5849 5.21628 15.7217 5.30182 15.9092C5.5338 16.418 6.22894 16.4196 6.48223 15.9118C6.51537 15.8454 6.53609 15.7064 6.53537 15.5555C6.53473 15.4195 6.38849 13.1993 6.2104 10.6217C5.91851 6.39696 5.87953 5.92082 5.81472 5.7891C5.65764 5.46998 5.24008 5.33292 4.92707 5.49781ZM8.23011 5.49005C8.06756 5.56656 7.90504 5.74729 7.86474 5.89622C7.82934 6.02708 7.82984 15.6866 7.86524 15.8177C7.90314 15.9581 8.09987 16.1812 8.23881 16.2414C8.3868 16.3054 8.6132 16.3054 8.76119 16.2414C8.90013 16.1812 9.09686 15.9581 9.13476 15.8177C9.17016 15.6866 9.17066 6.02708 9.13526 5.89622C9.06952 5.65316 8.7598 5.42193 8.5 5.42193C8.43111 5.42193 8.30964 5.45258 8.23011 5.49005ZM11.5473 5.45799C11.3855 5.52905 11.2536 5.65026 11.1838 5.79218C11.121 5.91985 11.0786 6.43874 10.7896 10.6217C10.6115 13.1993 10.4653 15.4195 10.4646 15.5555C10.4639 15.7064 10.4846 15.8454 10.5178 15.9118C10.7711 16.4195 11.4661 16.418 11.6983 15.9092C11.7839 15.7215 11.7951 15.587 12.1184 10.8545L12.4506 5.99261L12.3678 5.8153C12.2591 5.58259 12.0663 5.44861 11.8173 5.43276C11.7151 5.42627 11.5936 5.43762 11.5473 5.45799Z" fill="#686868"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="miniCartBodyItemUpgradeContentBottom">
                                <div class="miniCartBodyItemUpgradeContentBenefits">
                                    ${HTML}
                                </div>
                                ${discountHTML}
                                <div class="miniCartBodyItemUpgradeContentFrequency" selling-plan="${sellingPlanID}">
                                    <div class="miniCartBodyItemUpgradeContentFrequencyTitle">Delivered every:</div>
                                    <div class="miniCartBodyItemUpgradeContentFrequencySelect">
                                        <div class="miniCartBodyItemUpgradeContentFrequencySelectLabel miniCartBodyItemUpgradeContentFrequencySelectRow">
                                            ${sellingPlanName}
                                        </div>
                                        <div class="miniCartBodyItemUpgradeContentFrequencySelectOptions">
                                            ${plansHTML}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }

        // get the other pack sizes for the product
        function productPacks() {

            // if this is a 12 boxes of tissue product, hide the pack options
            if (item.handle.includes('12-boxes')) {
                return "";
            }

            // define preselected pack
            let defaultSelection = null;

            // define main handles object
            let mainHandles = {};

            // keep only the handles that belong to the current store
            Object.entries(handleToVariantID).forEach(([key, value]) => {
                if (key.includes('-ca') === isCanada) {
                    mainHandles[key] = value;
                }
            });

            // filter to only include the same product type (ppt vs. non-ppt)
            const isPpt = item.handle.includes('-ppt');
            Object.keys(mainHandles).forEach(key => {
                if (key.includes('-ppt') !== isPpt) {
                    delete mainHandles[key];
                }
            });

            // determine the preselected pack
            Object.entries(mainHandles).forEach(([key, value]) => {
                if (parseInt(value) === parseInt(item.variant_id)) {
                    defaultSelection = [key, value];
                }
            });

            // format title for default handle
            let defaultTitle = '';
            if (defaultSelection != null) {
                defaultTitle = formatPackLabel(defaultSelection[0]);
            }


            // set it up with the default main handle if not null
            let HTML = `
                <div class="miniCartBodyItemUpgradeContentPacksItemDefault" data-id="${defaultSelection[1]}">
                    ${defaultTitle}
                </div>
            `;

            let packsHTML = "";

            // if this is an upsell item replacing in cart, remove the other packs that aren't also replace in cart upsells
            if (upsellMatrixEntry(variantIDToProduct[item.variant_id]?.handle)?.replace_in_cart === true) {
                // filter mainHandles to only include items that replace in cart
                Object.entries(mainHandles).forEach(([key, value]) => {
                    if (!(upsellMatrixEntry(variantIDToProduct[value]?.handle)?.replace_in_cart === true)) {
                        delete mainHandles[key];
                    }
                });
            }
            // if this isn't an upsell item in general, remove the upsell items from the pack options
            else {
                // filter mainHandles to only include non-upsell items
                Object.entries(mainHandles).forEach(([key, value]) => {
                    if (upsellMatrixEntry(variantIDToProduct[value]?.handle)) {
                        delete mainHandles[key];
                    }
                });
            }

            // also make sure to remove default selection from the pack options
            if (defaultSelection != null) {
                Object.entries(mainHandles).forEach(([key, value]) => {
                    if (parseInt(value) === parseInt(item.variant_id)) {
                        delete mainHandles[key];
                    }
                });
            }

            // get the main handles for the product packs
            Object.entries(mainHandles).forEach(([key, value]) => {
                // only add the pack if it's not the default/selected one
                if (parseInt(value) === defaultSelection[1]) {
                    return;
                }

                packsHTML += `
                    <div class="miniCartBodyItemUpgradeContentPacksContainerItem" data-id="${value}">
                        ${formatPackLabel(key)}
                    </div>
                `;
            });

            // add option to remove the upsell item if it's a pack that's replacing in cart
            if (upsellMatrixEntry(variantIDToProduct[item.variant_id]?.handle)?.replace_in_cart === true) {
                packsHTML += `
                    <div class="miniCartBodyItemUpgradeContentPacksContainerItem remove" data-id="${item.variant_id}">
                        Remove Tissue
                    </div>
                `;
            }

            HTML += `
                <div class="miniCartBodyItemUpgradeContentPacksContainer">
                    ${packsHTML}
                </div>
            `;
            return HTML;
        }

        function upsellItem() {
            // first check if this is an upsell item
            if (!upsellMatrixEntry(variantIDToProduct[item.variant_id]?.handle)) {
                return "";
            }

            // define html
            let HTML = ""

            // current upsell product
            const upsellProduct = variantIDToProduct[item.variant_id];

            // find the upsell in the matrix
            const matrixEntry = upsellMatrixEntry(upsellProduct.handle);

            // check if we're replacing in cart
            if (!matrixEntry.replace_in_cart) {
                return HTML;
            }
            // product title (not very pretty)
            const upsellTitle = upsellProduct.title.replace("PlantPaper", "").replace("16", "").replace("32", "").replace("96", "").replace("Rolls", "").replace("-", "").replace("+", "").replace("Tissues", "").trim().toLowerCase();

            // get the original product handle
            const sourceHandle = upsellMatrixSourceHandle(upsellProduct.handle);

            // declare price variables
            let realPrice = 0;
            let originalPrice = 0;
            let hasBundleDiscount = false;

            // check that we found the original product handle
            if (sourceHandle) {
                // get the variantID from the original product we found
                let product = variantIDToProduct[handleToVariantID[sourceHandle]];

                // determine the real price, changes based on if we have a subscription or not
                // we'll consolidate the bundle pricing together later
                if (item.selling_plan_allocation) {
                    // update the real price, calculated from the difference between the upsell sub price and
                    // original product sub price
                    realPrice = (upsellProduct.variants[0].selling_plan_allocations[0].per_delivery_price - product.variants[0].selling_plan_allocations[0].per_delivery_price);
                    originalPrice = product.variants[0].selling_plan_allocations[0].per_delivery_price;
                } else {
                    // update the real price, calculated from the difference between the upsell price and
                    // original product price
                    realPrice = (upsellProduct.variants[0].price - product.variants[0].price);
                    originalPrice = product.variants[0].price;
                }

                // every replace_in_cart bundle in upsellMatrix has a bundlePricing entry, so its
                // presence is what marks the line as discounted
                if (bundlePricing[upsellProduct.handle]) {
                    hasBundleDiscount = true;
                }
            }

            // subscription bundles have no purchase type label, only OTP
            let purchaseTypeHTML = "";
            if (!item.selling_plan_allocation) {
                purchaseTypeHTML = `<span>One-time purchase</span>`;
            }

            // strike through price when there's a compare price
            let compareHTML = "";
            if (hasBundleDiscount && item.selling_plan_allocation) {
                compareHTML = price(upsellProduct.variants[0].price);
            }

            let firstOrder = "";

            // only render money off a code shopify confirms is applicable to this cart. no allocation
            // on this line means the code landed elsewhere in the cart
            if (welcomeDiscountApplied() && item.selling_plan_allocation && item.total_discount) {
                // subtract off the pre-code bundle price shown above, not final_line_price - that one
                // already has the allocation taken out, so using it here charges the discount twice.
                // the allocation covers the whole line, so bring it down to the per bundle price
                firstOrder = `<span class="firstOrder">First order ${price((realPrice + originalPrice) - (item.total_discount / item.quantity))}</span>`
            }

            HTML += `
                <div class="miniCartBodyItemUpsell" data-handle="${upsellProduct.handle}">
                    <div class="miniCartBodyItemUpsellWrapper">
                        <div class="miniCartBodyItemUpsellWrapperTop">
                            <div class="miniCartBodyItemUpsellWrapperTopTitle">
                                ${upsellTitle} Tissue
                            </div>
                        </div>
                        <div class="miniCartBodyItemUpsellWrapperBottomPrice">
                            ${purchaseTypeHTML}
                            <div class="miniCartBodyItemUpsellWrapperBottomPriceWrap">
                                <div class="miniCartBodyItemUpsellWrapperBottomPriceCompare">
                                    ${compareHTML}
                                </div>
                                <div class="miniCartBodyItemUpsellWrapperBottomPriceReal">
                                    ${price(realPrice + originalPrice)}
                                </div>
                                ${firstOrder}
                            </div>
                        </div>
                    </div>
                </div>
            `;

            return HTML;
        }


        // get prod title
        let itemTitle = item.product_title;

        // update the format of the title
        if (itemTitle.toLowerCase().includes("plantpaper - ") && !itemTitle.toLowerCase().includes("tissues")) {
            itemTitle = itemTitle.replace("PlantPaper - ", "").replace("Rolls", "rolls") + " PlantPaper"
        } else if (itemTitle.toLowerCase().includes("tissues - ")) {
            let newTitle = itemTitle.replace("PlantPaper Tissues - ", "").replace("Boxes", "");
            itemTitle = newTitle + "boxes Tissue";
        } else if (itemTitle.toLowerCase().includes("towel - ")) {
            // paper towel titles read "PlantPaper Towel - 16 Rolls"; stack the size under the name
            itemTitle = itemTitle.split(" - ").join("<br>");
        }

        // check if the plan had been edited based on the line item property
        function editedPlan() {
            return !!item.properties?._edited_plan;
        }

        // flag edited plan items
        let editClass = "";
        if (editedPlan() === true) {
            editClass = "edit";
        }

        // show the quantity controls for multi quantity or edited plan items
        let quantityClass = "";
        if (item.quantity >= 2 || editedPlan() === true) {
            quantityClass = "active";
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem ${isSubscription()} ${editClass}" key="${item.key}" data-id="${item.variant_id}">
                <div class="miniCartBodyItemContent">
                    <div class="miniCartBodyItemContentTopWrapper">
                        <div class="miniCartBodyItemContentTop">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5101 0.0567294C15.6423 0.341027 14.316 1.19028 12.8625 2.39223C11.1714 3.79083 7.74236 7.06243 6.22965 8.72055L5.8952 9.08727L4.58051 8.50988C1.93653 7.34863 0.563909 7.17018 0.132017 7.93155C-0.129306 8.39208 -0.04932 8.55754 0.799352 9.31306C2.36842 10.7098 3.52514 12.1015 5.08578 14.4702C5.6555 15.3348 6.12595 15.9653 6.21315 15.981C6.63966 16.0574 6.74005 15.9466 7.25801 14.8279C7.90328 13.4341 9.2898 10.9181 10.0745 9.7169C11.8483 7.00155 13.9384 4.60034 16.3525 2.50457C17.9371 1.12884 18.1399 0.853807 17.9326 0.361373C17.8147 0.0815094 16.9801 -0.0972551 16.5101 0.0567294Z" fill="#153BFE"/>
                            </svg>
                            <!-- if upsell, show label, otherwise use normal title -->
                            <div class="miniCartBodyItemContentTopTitle">
                                ${upsellTitle() || itemTitle}
                            </div>
                            <div class="miniCartBodyItemContentTopQuantity ${quantityClass}">
                                <span class="miniCartBodyItemContentTopQuantityTitle">QTY.</span>
                                <div class="miniCartBodyItemContentTopQuantityWrapper">
                                    <button class="miniCartBodyItemContentTopQuantityMinus">-</button>
                                    <div class="miniCartBodyItemContentTopQuantityCount">${item.quantity}</div>
                                    <button class="miniCartBodyItemContentTopQuantityPlus">+</button>
                                </div>
                            </div>
                            <div class="miniCartBodyItemContentTopPriceWrapper">
                                ${purchaseType()}
                                <div class="miniCartBodyItemContentTopPrice">
                                    ${priceHTML()}
                                    ${discountHTML()}
                                </div>
                            </div>
                        </div>
                        ${upsellItem()}
                    </div>
                    <div class="miniCartBodyItemContentBottom">
                        ${upgradeHTML()}
                        ${frequencyOptions()}
                    </div>
                </div>
            </div>
        `);
    });

    // update upsells function
    updateUpsells();

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = cart.items.find(item => item.key === key)?.quantity;

        // minus
        element.querySelector(".miniCartBodyItemContentTopQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemUpgradeContentRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemContentTopQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemUpgradeContentRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemContentTopQuantityCount`).textContent = quantity;

            // add loading to cart
            setCartLoading(true);

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // open cart
            await openCart(true);
        }

        // function to trigger item edit property
        async function triggerItemEdit() {

            // check if item has a selling plan, if not exit
            if (!cart.items.find(item => item.key === key).selling_plan_allocation) {
                return;
            }

            // add loading to cart
            setCartLoading(true);

            // update the edit flag on the item, carrying the _added_at stamp through since properties are replaced as a whole
            cart = await changeProduct({
                id: key,
                quantity: quantity,
                properties: {
                    "_edited_plan": "true",
                    "_added_at": cart.items.find(item => item.key === key)?.properties?._added_at
                }
            });

            // fetch cart
            await openCart(true);
        }

        // function to update item new plan property
        async function updateItemPlan(plan) {

            // check if item has a selling plan, if not exit
            if (!cart.items.find(item => item.key === key).selling_plan_allocation) {
                return;
            }

            // add loading to cart
            setCartLoading(true);

            // get the selected selling plan id
            let sellingPlanID = parseInt(plan);

            // update the selling plan on the item
            cart = await changeProduct({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            // fetch cart
            await openCart(true);
        }

        // function to update item new variant property
        async function updateVariant(variantID) {
            // add loading to cart
            setCartLoading(true);

            // if this item had a subscription, pick the plan for the new variant via its default cadence, the original cadence, or its first plan
            const originalItem = cart.items.find(item => item.key === key);
            let sellingPlan = null;
            if (originalItem?.selling_plan_allocation) {
                sellingPlan = matchSellingPlan(variantIDToProduct[variantID], originalItem.selling_plan_allocation.selling_plan?.name);
            }

            // remove this product from the cart
            await changeProduct({
                id: key,
                quantity: 0,
            });

            // add new product to cart, carrying the original _added_at stamp so the line keeps its position
            await addProduct({
                items: [{
                    quantity: quantity,
                    id: variantID,
                    selling_plan: sellingPlan,
                    properties: {
                        "_edited_plan": "true",
                        "_added_at": originalItem?.properties?._added_at
                    }
                }]
            });

            // open cart
            await openCart();
        }

        // listen for upgrade button toggle
        element.querySelector(".miniCartBodyItemUpgradeContentToggle")?.addEventListener("click", async function () {

            // get the needed item info for the upgrade
            const key = this.dataset.key;
            const sellingPlanID = parseInt(this.dataset.plan);
            const quantity = parseInt(this.dataset.quantity);

            // checkbox
            const checkbox = this.querySelector('.miniCartBodyItemUpgradeContentToggle input[type="checkbox"]');

            // add loading to cart
            setCartLoading(true);

            // changing properties replaces them all, so carry the _added_at stamp through to keep the line's position
            const addedStamp = cart.items.find(item => item.key === key)?.properties?._added_at;

            // if not currently checked and clicked to upgrade to subscription
            if (checkbox.checked === false) {
                // check the box
                checkbox.checked = true;

                // add the selling plan in place so the line keeps its position in the cart
                await changeProduct({
                    id: key,
                    quantity: quantity,
                    selling_plan: sellingPlanID,
                    properties: {
                        "_edited_plan": "true",
                        "_added_at": addedStamp
                    }
                });

                // fetch cart
                await openCart(false);

            } else {
                // uncheck the box
                checkbox.checked = false;

                // remove the selling plan
                await changeProduct({
                    id: key,
                    quantity: quantity,
                    selling_plan: null,
                    properties: {
                        "_original_plan": sellingPlanID,
                        "_added_at": addedStamp
                    }
                });

                // fetch cart
                await openCart(false);
            }

        });

        // listen for edit button click
        element.querySelectorAll('.miniCartBodyItemFrequencySelectOptionsEdit, .editFrequency').forEach(button => {
            button?.addEventListener("click", function () {
                triggerItemEdit();
            })
        })

        // listen for frequency or pack select
        element.querySelectorAll('.miniCartBodyItemUpgradeContentFrequencySelect, .miniCartBodyItemUpgradeContentPacksItemDefault').forEach(item => {
            item.addEventListener("click", async function () {
                // toggle active class
                this.classList.toggle('active')
            })
        })

        // listen for frequency change
        element.querySelectorAll(".miniCartBodyItemUpgradeContentFrequencySelectOption").forEach(function (element) {
            element.addEventListener("click", function () {
                let sellingPlanID = parseInt(this.getAttribute("selling_plan"));
                // update the plan data attribute on needed elements
                this.closest('.miniCartBodyItemUpgradeContent').querySelector('.miniCartBodyItemUpgradeContentToggle').dataset.plan = sellingPlanID;

                // update label
                this.parentElement.parentElement.querySelector(".miniCartBodyItemUpgradeContentFrequencySelectLabel").textContent = this.textContent;

                // update the selling plan on the item
                updateItemPlan(sellingPlanID);
            });
        })

        // listen for pack change
        element.querySelectorAll(".miniCartBodyItemUpgradeContentPacksContainerItem:not(.remove)").forEach(async function (element) {
            element.addEventListener("click", function () {
                let variantID = parseInt(this.dataset.id);
                updateVariant(variantID);
            });
        })

        // listen for pack remove (when pack is replacing in cart)
        element.querySelectorAll('.miniCartBodyItemUpgradeContentPacksContainerItem.remove').forEach(button => {
            button.addEventListener('click', async function () {
                // get the key
                const key = element.getAttribute("key");

                // get the product
                const product = cart.items.find(item => item.key === key);

                // get the upsell handle
                let handle = variantIDToProduct[cart.items.find(item => item.key === key).variant_id]?.handle;

                // use the upsell handle with the matrix to find the original product
                const sourceHandle = upsellMatrixSourceHandle(handle);

                if (sourceHandle) {
                    // get the variantID
                    let variantID = handleToVariantID[sourceHandle];

                    // add loading to cart
                    setCartLoading(true);

                    // if the replaced item had a subscription, match the original product's plan to its cadence
                    let sellingPlan = null;
                    if (product.selling_plan_allocation) {
                        sellingPlan = matchSellingPlan(variantIDToProduct[variantID], product.selling_plan_allocation.selling_plan?.name);
                    }

                    // remove this product from the cart
                    await changeProduct({
                        id: key,
                        quantity: 0,
                    });

                    // add new product to cart, carrying the original _added_at stamp so the line keeps its position
                    await addProduct({
                        items: [{
                            quantity: product.quantity,
                            id: variantID,
                            selling_plan: sellingPlan,
                            properties: {
                                "_added_at": product.properties?._added_at
                            }
                        }]
                    });

                    // open cart
                    await openCart();
                }
            })
        });
    });
}

// close dropdowns when clicking outside
document.querySelector('#miniCart').addEventListener('click', function (e) {
    const activeDropdowns = document.querySelectorAll('.miniCartBodyItemUpgradeContentFrequencySelect, .miniCartBodyItemUpgradeContentPacksItemDefault');
    activeDropdowns.forEach(dropdown => {
        if (!dropdown?.contains(e.target)) {
            dropdown?.classList.remove('active');
        }
    });
});

// close cart function
function closeCart() {
    // hide sections
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector('#miniCart').classList.remove("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartContent").classList.remove("active");
    document.querySelector("#miniCart").close();
}

// manual discount code add
if (document.querySelector('#miniCartFooterDiscount')) {
    document.querySelector('#miniCartFooterDiscountField').addEventListener("submit", async function (e) {
        // prevent default form submission
        e.preventDefault();

        // get the user input value
        const inputValue = this.querySelector('#miniCartFooterDiscountFieldInput').value;
        if (inputValue) {
            // add loading to cart
            setCartLoading(true);

            let discounts = ""

            // check if the cart already has the code applied
            if (cart.discount_codes?.find(code => code.code.toLowerCase() === inputValue.toLowerCase() && code.applicable === true)) {
                // remove loading from cart
                setCartLoading(false);

                // show the error message
                discountInvalid.innerHTML = "This code has already been applied.";
                discountInvalid.classList.add("active");
                return;
            }

            try {
                // only clear first if a code is already on the cart, so we don't fire a redundant update on a clean cart
                if (cart.discount_codes?.length > 0) {
                    await updateCart({discount: ""});
                }

                cart = await updateCart({discount: inputValue});

                // fetch the cart again to get the updated discount codes
                await openCart();

                // loop through discount codes and check if applicable
                cart.discount_codes.forEach((item) => {
                    if (item.applicable === true) {
                        discounts += `${item.code},`
                    }
                })

                // if no applicable codes, show code is not valid and exit
                if (!discounts) {
                    // remove loading from cart
                    setCartLoading(false);

                    // in case the text is 'applied' from a previous code, remove it                    document.querySelector('#miniCartFooterDiscountCodeWrap').classList.remove('active');
                    discountButton.innerHTML = "Apply";
                    discountButton.classList.remove("unclickable");

                    // remove valid class from field
                    this.classList.remove("validCode");

                    // remove discount code from footer if it's showing
                    discountWrap.classList.remove('active');

                    // show the error message - if it's the welcome discount again, show the special message
                    if (hasWelcomeCode && inputValue === welcomeDiscount.code) {
                        discountInvalid.innerHTML = `Sorry, you're not eligible for the ${welcomeDiscount.code} discount.`;
                    } else {
                        discountInvalid.innerHTML = "This code is not valid.";
                    }
                    discountInvalid.classList.add("active");
                    return;
                }

                // remove loading from cart
                setCartLoading(false);

                // hide the error message if it's showing
                discountInvalid.classList.remove("active");

            } catch (error) {
                console.error(error)
            }
        }
    })

    // add event listener to the discount code input field to remove the discount code if the user edits the code after applying it
    document.querySelector('#miniCartFooterDiscountFieldInput').addEventListener("input", async function () {
        // if the field has the validCode class, that means a code has been applied and the user is now editing it, we should make the button clickable again
        if (this.closest('#miniCartFooterDiscountField').classList.contains("validCode")) {
            let button = this.closest('#miniCartFooterDiscountField').querySelector('#miniCartFooterDiscountFieldButton');
            // update the text back to apply
            button.innerHTML = "Apply";
            // make clickable again
            button.classList.remove("unclickable");
        }
    })
}

// clean up discount code on cart update (if the code is no longer valid, etc.)
function cleanUpDiscountCode() {
    // in case the text is 'applied' from a previous code, remove it
    discountWrap.classList.remove('active');
    discountWrap.innerHTML = "";
    discountButton.innerHTML = "Apply";
    discountButton.classList.remove("unclickable");

    // remove valid class from field and clear any stale code text
    document.querySelector('#miniCartFooterDiscountField').classList.remove("validCode");
    document.querySelector('#miniCartFooterDiscountFieldInput').value = "";

    // hide the error message if it's showing, unless the welcome code is one the customer isn't
    // eligible for - that denial has to survive the reset so they see it before checkout
    if (!welcomeCodeRefused()) {
        discountInvalid.classList.remove("active");
    }
}

// update the discount text if no items have their dropdowns open
function updateDiscountText() {

    // check if there are any subscription items
    let numSubs = 0
    cart.items.forEach((item) => {
        if (item.selling_plan_allocation) {
            numSubs++;
        }
    })

    // No subs? Remove and exit.
    if (numSubs === 0) {
        document.querySelector('#miniCartFooterCode').classList.remove('active');
        return;
    }

    // declare total price variable
    let totalPrice = 0;

    // get the cart price after the 20% subscription discount
    cart.items.forEach((item) => {
        if (item.selling_plan_allocation) {
            totalPrice = price(((item.final_line_price * 0.2)), true);
        }
    })

    // get the discount element
    let discount = document.querySelector('#miniCartFooterCode');
    document.querySelector('#miniCartFooterCode').classList.add('active');

    // update the text
    discount.innerHTML = `Use code: <u class="bold">Welcome20</u> at checkout for an additional <u class="bold">${totalPrice}</u> off your first order`;
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// outside click close
document.querySelector("#miniCart").addEventListener("click", function (e) {
    // check that we're clicking outside AND that this wasn't a swiper slide motion
    if (e.target === this && upsellsTransitioning === false) {
        closeCart();
    }
})

// escape key close
document.querySelector("#miniCart").addEventListener("close", function (e) {
    closeCart();
})
/********************* Upsells *********************/

// populate the upsell products if needed
const upsellContainer = document.querySelector("#miniCartUpsellsContainer");

// swiper instance for the upsell slider, recreated on every cart render
let upsellSwiper = null;

// categorize a product handle; ppt must be checked first since ppt handles also contain "rolls"
function handleCategories(handle) {
    if (handle.includes('-ppt')) {
        return {tp: false, ppt: true, tissue: false};
    }
    // bundle handles like 16-rolls-4-boxes contain both and count as tp and tissue
    return {tp: handle.includes('rolls'), ppt: false, tissue: handle.includes('boxes')};
}

// append the CA suffix to a base handle when on the Canadian store
function localizeHandle(handle) {
    if (isCanada === true) {
        return `${handle}-ca`;
    }
    return handle;
}

// toilet paper upsell card
function tpUpsellCard() {
    return {
        type: "tp",
        handle: localizeHandle("16-rolls"),
        replace: false,
        triggerKey: "",
        title: "PlantPaper",
        atcTitle: "Add PlantPaper",
        badge: "",
        bullets: [
            "Tree-free, toxin-free toilet paper",
            "Made of soft, strong,",
            "3 ply, FSC-certified bamboo"
        ],
        image: "https://cdn.shopify.com/s/files/1/0247/1202/0052/files/DSCF6444_115.png?v=1768488673"
    };
}

// paper towel upsell card, shows a badge instead of the review stars
function pptUpsellCard() {
    return {
        type: "ppt",
        handle: localizeHandle("16-rolls-ppt"),
        replace: false,
        triggerKey: "",
        title: "PlantPaper Towel",
        atcTitle: "Add PlantPaper Towel",
        badge: "New!",
        bullets: [
            "Thicker. More Absorbent. Toxin-free.",
            "120 3-ply, 11”x5.5” sheets"
        ],
        image: "https://cdn.shopify.com/s/files/1/0247/1202/0052/files/DSCF0368_10.png?v=1781038837"
    };
}

// standalone facial tissue upsell card
function tissueUpsellCard() {
    return {
        type: "tissue",
        handle: localizeHandle("12-boxes"),
        replace: false,
        triggerKey: "",
        title: "Tissue",
        atcTitle: "Add Facial Tissue",
        badge: "",
        bullets: [
            "12 boxes, 60 tissues per box",
            "100% non-toxic, 3 ply",
            "Soft, strong, bleach-free bamboo"
        ],
        image: "https://cdn.shopify.com/s/files/1/0247/1202/0052/files/PlantPaper-Tissue-1_75.png?v=1771361139"
    };
}

// tissue bundle upsell card driven by the toilet paper item in the cart and the upsell matrix
function bundleUpsellCard() {
    // find the toilet paper line that triggers the bundle offer
    const triggerItem = cart.items.find(item => handleCategories(item.handle).tp);
    const matrixEntry = upsellMatrix[triggerItem?.handle];

    // no matrix entry for this toilet paper pack? no bundle card
    if (!matrixEntry) {
        return null;
    }

    // get the number of tissue boxes from the bundle handle for the card copy
    let handleName = matrixEntry.handle;
    if (handleName.includes('rolls-')) {
        handleName = handleName.slice(handleName.indexOf('rolls-') + 'rolls-'.length);
    }
    const numTissues = handleName.match(/\d+/g);

    // bundles that replace in cart read as a bundle, add on offers read as a plain add
    let atcTitle = "Bundle Facial Tissue";
    if (matrixEntry.replace_in_cart === false) {
        atcTitle = `Add Facial Tissue ${numTissues} boxes`;
    }

    return {
        type: "bundle",
        handle: matrixEntry.handle,
        replace: matrixEntry.replace_in_cart,
        triggerKey: triggerItem.key,
        title: "Tissue",
        atcTitle: atcTitle,
        badge: "",
        bullets: [
            `${numTissues} boxes, 60 tissues per box`,
            "100% non-toxic, 3 ply",
            "Soft, strong, bleach-free bamboo"
        ],
        image: "https://cdn.shopify.com/s/files/1/0247/1202/0052/files/PlantPaper-Tissue-1_75.png?v=1771361139"
    };
}

let upsellsTransitioning = false;

function updateUpsells() {
    // destroy the previous swiper instance so cart re-renders never double init
    if (upsellSwiper) {
        upsellSwiper.destroy(true, true);
        upsellSwiper = null;
    }

    // combine the categories of every cart item into cart level flags
    const cartHas = {tp: false, ppt: false, tissue: false};
    cart.items.forEach(item => {
        const categories = handleCategories(item.handle);
        if (categories.tp) {
            cartHas.tp = true;
        }
        if (categories.ppt) {
            cartHas.ppt = true;
        }
        if (categories.tissue) {
            cartHas.tissue = true;
        }
    });

    // build the ordered slide list based on what's missing from the cart
    let cards = [];
    if (cartHas.ppt && !cartHas.tp && !cartHas.tissue) {
        cards = [tpUpsellCard(), tissueUpsellCard()];
    } else if (cartHas.tp && !cartHas.ppt && !cartHas.tissue) {
        cards = [pptUpsellCard(), bundleUpsellCard()];
    } else if (cartHas.tissue && !cartHas.tp && !cartHas.ppt) {
        cards = [tpUpsellCard(), pptUpsellCard()];
    } else if (cartHas.ppt && cartHas.tp && !cartHas.tissue) {
        cards = [bundleUpsellCard()];
    } else if (cartHas.tp && cartHas.tissue && !cartHas.ppt) {
        cards = [pptUpsellCard()];
    } else if (cartHas.ppt && cartHas.tissue && !cartHas.tp) {
        cards = [tpUpsellCard()];
    }

    // drop any card without a product available on this store
    cards = cards.filter(card => card && handleToVariantID[card.handle]);

    // nothing to offer? hide the upsell area and exit
    if (cards.length === 0) {
        upsellContainer.innerHTML = "";
        document.querySelector('#miniCartUpsells').classList.remove('active');
        return;
    }

    // build all slides as one string and insert once
    let slidesHTML = "";
    cards.forEach(card => {
        slidesHTML += createUpsellHTML(card);
    });
    upsellContainer.innerHTML = `<div class="swiper-wrapper">${slidesHTML}</div>`;

    // show the upsell area
    document.querySelector('#miniCartUpsells').classList.add('active');

    // a lone card fills the row, multiple cards leave a peek of the next one on the right
    let slidesPerView = 1;
    if (cards.length > 1) {
        slidesPerView = 1.12;
    }

    // init the slider, watchOverflow disables swiping when nothing overflows
    upsellSwiper = new Swiper(upsellContainer, {
        slidesPerView: slidesPerView,
        spaceBetween: 12,
        watchOverflow: true,
        on: {
            sliderMove: function () {
                // update the upsells transitioning flag - only once
                if (upsellsTransitioning) {
                    return;
                }
                upsellsTransitioning = true;
            },
            transitionEnd: function () {
                // update the upsells transitioning flag - only once
                upsellsTransitioning = false;
            }
        }
    });
}


// determine the price per unit using handle
function pricePerUnit(card) {
    // resolve the upsell the handle is tied to; bail if the lookup misses so one bad handle can't break the whole render
    const upsell = variantIDToProduct[handleToVariantID[card.handle]];
    if (!upsell || !upsell.variants[0]) {
        return "";
    }

    const variant = upsell.variants[0];
    const trigger = cart.items.find(item => item.key === card.triggerKey);

    // if this is a bundle, bail
    if (card.replace === true && trigger) {
        return "";
    }

    // pull the first number out of the handle; without this, there's no per-unit price to show
    const countMatch = card.handle.match(/\d+/);
    if (!countMatch) {
        return "";
    }
    const count = parseInt(countMatch[0], 10);

    let real = null;

    // price the upsell on its own, using the subscription price when the cart has a subscription
    if (cart.items.find(item => item.selling_plan_allocation) && variant.selling_plan_allocations[0]) {
        real = variant.selling_plan_allocations[0].price;
    } else {
        real = variant.price;
    }

    // guard against a price we never resolved so we don't render a bogus $0
    if (real === null || isNaN(real)) {
        return "";
    }

    // real is in cents, so run the per-unit value back through price() for a formatted currency string
    return `${price(real)} (${price(real / count)}/roll)`;
}


// pricing markup shown next to the add button; only toilet paper doesn't show pricing
function upsellPricingHTML(card) {
    if (card.type === "tp") {
        return "";
    }

    // resolve the upsell product and the cart line a bundle offer is tied to
    const upsell = variantIDToProduct[handleToVariantID[card.handle]];
    const trigger = cart.items.find(item => item.key === card.triggerKey);

    let compare = "";
    let real = "";

    // a bundle replacing in cart prices relative to the item it replaces
    if (card.replace === true && trigger) {
        if (trigger.selling_plan_allocation) {
            real = (upsell.variants[0].selling_plan_allocations[0].per_delivery_price - trigger.selling_plan_allocation.per_delivery_price);
        } else {
            real = (upsell.variants[0].price - trigger.price);
        }
    }
    // otherwise price the upsell on its own, using the subscription price when the cart has a subscription
    else {
        if (cart.items.find(item => item.selling_plan_allocation)) {
            real = upsell.variants[0].selling_plan_allocations[0].price;
        } else {
            real = upsell.variants[0].price;
        }
    }

    // check if we have special bundle pricing for this upsell
    if (bundlePricing[upsell.handle]) {
        compare = bundlePricing[upsell.handle] * 100;
    }
    // otherwise, check if the discount from the subscription is greater than the discount from just the price difference, and if so, apply the subscription discount language to the price
    else if (card.replace === true && trigger && ((upsell.variants[0].price - trigger.price) - Math.ceil(real)) > 0) {
        compare = (upsell.variants[0].price - trigger.price);
    } else if (card.replace === false && (upsell.variants[0].price - Math.ceil(real)) > 0) {
        compare = upsell.variants[0].price;
    }

    // update HTML
    let html = "";

    if (card.type === "ppt") {
        html += `<div class="miniCartUpsellsContainerItemATCPer">${pricePerUnit(card)}</div>`;
    } else {
        if (compare) {
            html += `<span class="miniCartUpsellsContainerItemATCCompare">+${price(compare)}</span>`;
        }
        html += `<span class="miniCartUpsellsContainerItemATCPrice">+${price(real)}</span>`;
    }
    return html;
}

function upsellDiscountHTML(card) {
    // only advertise the discount when shopify confirms it is applicable to this cart; that verdict
    // is already false unless an eligible subscription line is present
    if (!welcomeDiscountApplied()) {
        return "";
    }

    // get the pricing from the helper function
    const [, real] = computeUpsellPricing(card);

    let html = "";

    // get the discount price from the discount
    const discountedPrice = real - (real * (welcomeDiscount.percent / 100));

    // pull the first number out of the handle; without this, there's no per-unit price to show
    const countMatch = card.handle.match(/\d+/);
    const count = parseInt(countMatch[0], 10);
    const discountPer = price(discountedPrice / count);

    // format the discount name
    let discountName = welcomeDiscount.code?.toLowerCase().replace(/[0-9]/g, '');
    if (!!discountName) {
        discountName = discountName.charAt(0).toUpperCase() + discountName.slice(1);
    }

    if (card.type === "ppt" && !!discountPer) {
        html += `<div class="miniCartUpsellsContainerItemATCDiscount ppt">${discountName} discount first order <span>${price(discountedPrice)} (${discountPer}/roll)</span></div>`;
    } else if (card.type === "tp") {
        html += `<div class="miniCartUpsellsContainerItemATCDiscount tp">${welcomeDiscount.percent}% off ${discountName} discount applies</div>`;
    } else {
        html += `<div class="miniCartUpsellsContainerItemATCDiscount">${discountName} discount first order <span>${price(discountedPrice)}</span></div>`;
    }
    return html;
}

// helper function to calculate upsell pricing
function computeUpsellPricing(card) {
    // resolve the upsell product and the cart line a bundle offer is tied to
    const upsell = variantIDToProduct[handleToVariantID[card.handle]];
    const trigger = cart.items.find(item => item.key === card.triggerKey);

    let compare = "";
    let real = "";

    // a bundle replacing in cart prices relative to the item it replaces
    if (card.replace === true && trigger) {
        if (trigger.selling_plan_allocation) {
            real = (upsell.variants[0].selling_plan_allocations[0].per_delivery_price - trigger.selling_plan_allocation.per_delivery_price);
        } else {
            real = (upsell.variants[0].price - trigger.price);
        }
    }
    // otherwise price the upsell on its own, using the subscription price when the cart has a subscription
    else {
        if (cart.items.find(item => item.selling_plan_allocation)) {
            real = upsell.variants[0].selling_plan_allocations[0].price;
        } else {
            real = upsell.variants[0].price;
        }
    }

    // check if we have special bundle pricing for this upsell
    if (bundlePricing[upsell.handle]) {
        compare = bundlePricing[upsell.handle] * 100;
    }
    // otherwise, check if the discount from the subscription is greater than the discount from just the price difference, and if so, apply the subscription discount language to the price
    else if (card.replace === true && trigger && ((upsell.variants[0].price - trigger.price) - Math.ceil(real)) > 0) {
        compare = (upsell.variants[0].price - trigger.price);
    } else if (card.replace === false && (upsell.variants[0].price - Math.ceil(real)) > 0) {
        compare = upsell.variants[0].price;
    }

    // return the pricing
    return [compare, real];
}

// helper function to build a single upsell slide string
function createUpsellHTML(card) {
    // build the bullet list
    let bulletsHTML = "";
    card.bullets.forEach(bullet => {
        bulletsHTML += `<span>${bullet}</span><br>`;
    });

    // if this is a ppt upsell, show the actual product sizing
    let sizing = "";
    if (card.type === 'ppt') {
        // replace bundle handles read "num1-rolls-num2-boxes", so grab the second number (boxes); standalone handles use the first (rolls)
        const counts = card.handle.match(/\d+/g) || [];
        const count = card.replace === true ? counts[1] : counts[0];
        const unit = card.replace === true ? "boxes" : "rolls";
        if (count) {
            sizing = ` - ${count} ${unit}`;
        }
    }
    // default to the review stars block, override with a badge when the card has one
    let topRightHTML = `
        <div class="miniCartUpsellsContainerItemTopTextStars">
            <svg width="57" height="12" viewBox="0 0 57 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.75757 0L7.05022 3.97838L11.2333 3.97838L7.84912 6.43715L9.14178 10.4155L5.75757 7.95676L2.37335 10.4155L3.66601 6.43715L0.281796 3.97838L4.46491 3.97838L5.75757 0Z" fill="#153BFE"/>
                <path d="M17.2732 0L18.5658 3.97838L22.749 3.97838L19.3647 6.43715L20.6574 10.4155L17.2732 7.95676L13.889 10.4155L15.1816 6.43715L11.7974 3.97838L15.9805 3.97838L17.2732 0Z" fill="#153BFE"/>
                <path d="M28.7888 0L30.0815 3.97838L34.2646 3.97838L30.8804 6.43715L32.173 10.4155L28.7888 7.95676L25.4046 10.4155L26.6973 6.43715L23.313 3.97838L27.4962 3.97838L28.7888 0Z" fill="#153BFE"/>
                <path d="M39.7263 0L41.019 3.97838L45.2021 3.97838L41.8179 6.43715L43.1105 10.4155L39.7263 7.95676L36.3421 10.4155L37.6348 6.43715L34.2505 3.97838L38.4337 3.97838L39.7263 0Z" fill="#153BFE"/>
                <path d="M51.2419 0L52.5346 3.97838L56.7177 3.97838L53.3335 6.43715L54.6262 10.4155L51.2419 7.95676L47.8577 10.4155L49.1504 6.43715L45.7662 3.97838L49.9493 3.97838L51.2419 0Z" fill="#153BFE"/>
            </svg>
            <span class="miniCartUpsellsContainerItemTopTextStarsText">
                5.2K 5-star reviews
            </span>
        </div>
    `;
    if (card.badge) {
        topRightHTML = `<div class="miniCartUpsellsContainerItemTopTextBadge">${card.badge}</div>`;
    }

    // pricing markup for cards that show a price next to the button
    const pricingHTML = upsellPricingHTML(card);

    // pricing markup for auto applied discount
    const discountHTML = upsellDiscountHTML(card);

    // build the slide
    return `
        <div class="swiper-slide miniCartUpsellsContainerItem" data-upsell-type="${card.type}" data-upsell-handle="${card.handle}" data-replace="${card.replace}" data-trigger-key="${card.triggerKey}">
            <div class="miniCartUpsellsContainerItemWrapper">
                <img class="miniCartUpsellsContainerItemImg" src="${card.image}">
                <div class="miniCartUpsellsContainerItemContent">
                    <div class="miniCartUpsellsContainerItemTop">
                        <div class="miniCartUpsellsContainerItemTopText">
                            <div class="miniCartUpsellsContainerItemTopTextTitle">
                                ${card.title} ${sizing}
                            </div>
                            ${topRightHTML}
                        </div>
                    </div>
                    <div class="miniCartUpsellsContainerItemMiddle">
                        <div class="miniCartUpsellsContainerItemMiddleBullets">
                            ${bulletsHTML}
                        </div>
                    </div>
                </div>
            </div>
            <div class="miniCartUpsellsContainerItemATCWrapper">
                <button class="miniCartUpsellsContainerItemATC">
                    + ${card.atcTitle}
                </button>
                ${pricingHTML}
            </div>
            ${discountHTML}
        </div>
    `;
}

// event delegation for upsell clicks since they are dynamically added
document.querySelector('#miniCartUpsellsContainer').addEventListener('click', async function (e) {
    let targetEl = e.target.closest('.miniCartUpsellsContainerItem')
    let selectRangeEl = e.target.closest('.miniCartUpsellsContainerItemATCSelectRange');

    // if the click is on the select range, we don't want to trigger the add to cart function
    if (selectRangeEl) {
        return;
    }
    if (targetEl) {
        await addUpsells(targetEl);
    }
})

// add upsells on click
async function addUpsells(el) {
    // make sure the product data feed has loaded before reading the maps
    await productDataReady;

    // read the card info from the clicked slide
    const upsellHandle = el.dataset.upsellHandle;
    const replaceInCart = el.dataset.replace === "true";
    const triggerKey = el.dataset.triggerKey;

    // resolve the upsell product, exit if it's not available
    const upsellProduct = variantIDToProduct[handleToVariantID[upsellHandle]];
    if (!upsellProduct) {
        return;
    }

    // add loading to cart
    setCartLoading(true);

    // if the cart has a subscription item, match the upsell to its cadence
    let sellingPlan = null;
    const subItem = cart.items.find(item => item.selling_plan_allocation);
    if (subItem) {
        sellingPlan = matchSellingPlan(upsellProduct, subItem.selling_plan_allocation.selling_plan?.name);
    }

    // the cart line a bundle offer is tied to, used for quantity matching and replacement
    const triggerItem = cart.items.find(item => item.key === triggerKey);

    // default to a single unit, bundle offers match the trigger line quantity
    let quantity = 1;
    if (triggerItem) {
        quantity = triggerItem.quantity;
    }

    // if the upsell replaces in cart, remove the original item from the cart first
    if (replaceInCart === true && triggerItem) {
        await changeProduct({
            id: triggerItem.key,
            quantity: 0,
        });
    }

    // new products land last with a fresh stamp; replacements (16+4 / 32+8) inherit the
    // stamp of the line they swap out so they keep its position in the cart
    let addedAt = Date.now();
    if (replaceInCart === true && triggerItem) {
        addedAt = triggerItem.properties?._added_at;
    }

    // build the add payload. New products start in the edit state (unfolded, showing the
    // Subscribe & Save options, same as clicking Edit); replacements keep the standard
    // folded look of the line they swap out.
    const upsellItem = {
        quantity: quantity,
        id: upsellProduct.variants[0].id,
        selling_plan: sellingPlan,
        properties: {
            "_added_at": addedAt
        }
    };
    if (replaceInCart === false) {
        upsellItem.properties["_edited_plan"] = "true";
    }

    // add the upsell to the cart
    await addProduct({
        items: [upsellItem]
    });

    // remove loading
    setCartLoading(false);

    // refresh cart
    await openCart();

}

// add to cart button
document.querySelector('#miniCartFooterCheckout')?.addEventListener("click", async function () {
    // add loading
    this.classList.add("loading");

    // proceed to checkout
    this.classList.remove("loading");
    window.location.href = "/checkout";

})

// open cart
document.querySelectorAll('.toggleCart').forEach((item) => {
    item.addEventListener('click', async function () {
        await openCart(true);
    })
})

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}